export default __webpack_public_path__ + "static/media/die.fe00861b.jpg";